import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

export default function RequireGuestAuth({ children }) {
  const { isAuthenticated } = useOutletContext();
  if (!isAuthenticated) {
    return <Navigate to=".." replace />;
  }
  return children;
}
